import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  getObjectiveEntrepreneurshipSelectorsState,
  getObjectiveMarriageSelectorsState,
  getObjectiveOthersSelectorsState,
  getObjectivePropertySelectorsState,
  getObjectiveRetirementSelectors,
  getObjectiveRetirementSelectorsState,
  getObjectiveTripsSelectorsState,
  getObjectiveVehiclesSelectorsState,
} from '../store/objective.selectors';
import {
  setObjectiveAction,
  setObjectivePropertyAction,
  setObjectiveRetirementAction,
} from '../store/objective.actions';
import {
  IObjectivesFormState,
  IObjectiveState,
} from '../store/objective.state';
import { GoalsService } from 'src/app/services/goals.service';
import { getCookie } from 'src/app/utils/get-cookie';


interface GoalsData {
  id: number;
  individuals_goal_id: number;
  name: string;
  check?: boolean;
  motive?: string;
  target_date?: string;
  investment_min?: string;
  investment_max?: string;
  observation?: string;
  current_age?: number;
  retirement_age?: number;
}

@Component({
  selector: 'app-form-objectives',
  templateUrl: './form-objectives.component.html',
  styleUrls: ['./form-objectives.component.scss'],
})
export class FormObjectivesComponent implements OnInit {

  isLoading = true
  selectedGoals: GoalsData[] = [];
  formsId: number = 0

  goToCollectData = false

  retirementGoal: GoalsData | undefined;
  tripsGoal: GoalsData | undefined;
  propertyGoal: GoalsData | undefined;
  vehiclesGoal: GoalsData | undefined;
  entrepreneurshipGoal: GoalsData | undefined;
  marriageGoal: GoalsData | undefined;
  othersGoal: GoalsData | undefined;

  checkRetirementState$: Observable<any>;
  checkTripsState$: Observable<any>;
  checkPropertyState$: Observable<any>;
  checkVehiclesState$: Observable<any>;
  checkEntrepreneurshipState$: Observable<any>;
  checkMarriageState$: Observable<any>;
  checkOthersState$: Observable<any>;
  
  dataRetirementState: IObjectivesFormState;
  dataTripsState: IObjectivesFormState;
  dataPropertyState: IObjectivesFormState;
  dataVehiclesState: IObjectivesFormState;
  dataEntrepreneurshipState: IObjectivesFormState;
  dataMarriageState: IObjectivesFormState;
  dataOthersState: IObjectivesFormState;
  
  checkObjectiveState$: Observable<IObjectiveState>;
  objectiveState: IObjectiveState;
  
  constructor(private store: Store, private goalsService: GoalsService) {}

  ngOnInit(): void {
    this.formsId = Number(getCookie('formsId'))
    this.loadSelectedGoals()
    this.getStates();
  }

  loadSelectedGoals(): void {
    this.isLoading = true
    this.goalsService.getGoals(this.formsId).subscribe((res: any) => {
      this.selectedGoals = res.data || [];
      this.retirementGoal = this.selectedGoals.find(obj => obj.individuals_goal_id === 1);
      this.tripsGoal = this.selectedGoals.find(obj => obj.individuals_goal_id === 2);
      this.propertyGoal = this.selectedGoals.find(obj => obj.individuals_goal_id === 3);
      this.vehiclesGoal = this.selectedGoals.find(obj => obj.individuals_goal_id === 4);
      this.entrepreneurshipGoal = this.selectedGoals.find(obj => obj.individuals_goal_id === 5);
      this.marriageGoal = this.selectedGoals.find(obj => obj.individuals_goal_id === 6);
      this.othersGoal = this.selectedGoals.find(obj => obj.individuals_goal_id === 7);
      this.isLoading = false

      if (this.selectedGoals.length === 0) {
        this.goToCollectData = true
      }
    });
  }

  getStates() {
    this.checkRetirementState$ = this.store.select(
      getObjectiveRetirementSelectorsState
    );
    this.checkRetirementState$.subscribe((value) => {
      this.dataRetirementState = value;
    });

    this.checkTripsState$ = this.store.select(getObjectiveTripsSelectorsState);
    this.checkTripsState$.subscribe((value) => {
      this.dataTripsState = value;
    });

    this.checkPropertyState$ = this.store.select(
      getObjectivePropertySelectorsState
    );
    this.checkPropertyState$.subscribe((value) => {
      this.dataPropertyState = value;
    });

    this.checkVehiclesState$ = this.store.select(
      getObjectiveVehiclesSelectorsState
    );
    this.checkVehiclesState$.subscribe((value) => {
      this.dataVehiclesState = value;
    });

    this.checkEntrepreneurshipState$ = this.store.select(
      getObjectiveEntrepreneurshipSelectorsState
    );
    this.checkEntrepreneurshipState$.subscribe((value) => {
      this.dataEntrepreneurshipState = value;
    });

    this.checkMarriageState$ = this.store.select(
      getObjectiveMarriageSelectorsState
    );
    this.checkMarriageState$.subscribe((value) => {
      this.dataMarriageState = value;
    });

    this.checkOthersState$ = this.store.select(
      getObjectiveOthersSelectorsState
    );
    this.checkOthersState$.subscribe((value) => {
      this.dataOthersState = value;
    });

    this.checkObjectiveState$ = this.store.select(
      getObjectiveOthersSelectorsState
    );
    this.checkObjectiveState$.subscribe((value) => {
      this.objectiveState = {
        ...(this.objectiveState = value),
      };
    });
  }

  setState(data: IObjectiveState) {
    this.store.dispatch(setObjectiveAction(data));
  }

  checkObjective() {
    this.objectiveState.check = true;
    this.setState(this.objectiveState);
  }
}
